import { Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, TemplateRef, ViewChild, ViewContainerRef } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { Overlay, OverlayRef } from '@angular/cdk/overlay';
import { FileTypeService } from 'src/app/modules/knowledge-base/services';
import { BlobUploadResponse, KnowledgeBaseConfigurationAttributeFileSizeFormat, StateDefinitionType } from 'src/app/model';
import { ServicecallService } from 'src/app';
import { Subscription } from 'rxjs';
import { CaseServiceService } from 'src/app/modules/case/case-service.service';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { Clipboard } from '@angular/cdk/clipboard';
import { masterConfigurationList } from 'src/app/constants/masterConfigList';
import { ProtusServiceService } from 'src/app/modules/protus/protus-service.service';

@Component({
  selector: 'app-dtc-case-info',
  templateUrl: './dtc-case-info.component.html',
  styleUrl: './dtc-case-info.component.css'
})
export class DtcCaseInfoComponent implements OnInit, OnChanges, OnDestroy {

  @Input() isCollapsed: boolean;
  @Input() dtcDetails: any;
  @Input() pageType: string;
  @Input() hideNavigation: boolean;
  @Input() stateDefinitions: StateDefinitionType;
  @Input() syncError : boolean;
  @Input() fromDate: number;  
  @Input() toDate:   number;
  @Output() collapse = new EventEmitter<any>();
  stateList: { value: string, displayName: string, key: string }[] = [];
  state = new FormControl(this.stateList?.[0]?.value, [Validators.required]);
  comment = new FormControl();
  isAddEvidence: boolean = false;
  showComments: boolean = false;
  uploadedEvidences: any[] = [];
  commentsList: any[] = [];
  openAddProtus: boolean = false;
  openReportReoccurenceForm: boolean = false;
  translatedText = '';
  idmUserName: string;
  protusExists: boolean = false;
  formType: string;

  //File Upload
  fileName = new FormControl();
  file = new FormControl();
  public fileContent: any;
  fileMimeTypes = [
    "image/jpeg",
    "image/png",
    "image/svg+xml",
    "image/gif"
  ];
  maxFileSize: number;
  isUploadFormSubmitted: boolean = false;
  startFileBlobUpload: boolean = false;
  protusDetails: any[] = [];
  private _blobResponse: any = {
    file: null
  };
  private _isAllFilesSelected: boolean = false;
  private _fileSelectedCount = 0;
  private _fileUploadedCount = 0;
  private readonly _TWO = 10;
  private _updateCaseSubscription: Subscription;
  private _getProtusHistorySubscription: Subscription;
  public selectedFileUrls: { name: string, url: string, id?: string }[] = [];

  //Rules
  private _fetchStatesSubsciption: Subscription;
  public ruleList = [];
  public applicableRules: { addEvidence: boolean, deleteEvidence: boolean, downloadEvidence: boolean, editProtusNumber: boolean, updateCase: boolean, protusAdd: boolean, reportReoccurence: boolean } = {
    addEvidence: false, deleteEvidence: false, downloadEvidence: false, editProtusNumber: false , updateCase: false, protusAdd: false, reportReoccurence: false
  };
  public actionsPerformed: { updateCase: boolean, deleteEvidence: boolean, changeState: boolean, protusAdd: boolean } = {
    updateCase: false, deleteEvidence: false, changeState: false, protusAdd: false };

  //RCA
  rcaList = [{value: "protusClosed", displayName: "Protus Closed" }];
  rca = new FormControl();

  //Pop over
  @ViewChild('popover', { static: true }) popoverTemplate!: TemplateRef<any>;
  private overlayRef!: OverlayRef;
  private _configurationsInfoSubscription: Subscription;


  constructor(private overlay: Overlay, private viewContainerRef: ViewContainerRef, private _fileTypeService: FileTypeService, public _service: ServicecallService,
    private _caseService: CaseServiceService, private _router: Router, private translate: TranslateService, private _clipboard: Clipboard, private _protusService: ProtusServiceService) { }

  ngOnInit(): any {
    this.idmUserName = localStorage?.getItem("idmUserName") ?  localStorage?.getItem("idmUserName") : null;
    const fileSizeFormat: KnowledgeBaseConfigurationAttributeFileSizeFormat = this._service.getConfiguration('fileSizeFormat') ? this._service.getConfiguration('fileSizeFormat') : [];
    this.maxFileSize = fileSizeFormat?.fileSizeFormat?.file;
    this.fetchProtusTitle();
    this.rcaList = this._service.getConfiguration('rcaList')?.rcaList ?? [{value: "Protus Closed", displayName: "Protus Closed" }];
  }

  ngOnChanges(): any {
    //Initialize the form controls
    this.state?.reset();
    this.comment?.reset();
    this.file?.reset();
    this.fileName?.reset();
    this.rca?.reset();
    this._setFileContent();
    this.isAddEvidence = false;
    this.showComments = false;
    this.uploadedEvidences = [];
    this.selectedFileUrls = [];
    this.actionsPerformed = { updateCase: false, deleteEvidence: false, changeState: false , protusAdd: false};
    this.applicableRules = { addEvidence: false, deleteEvidence: false, downloadEvidence: false, editProtusNumber: false , updateCase: false, protusAdd: false, reportReoccurence: false };
    this.stateList = [];

    //Initialize the form controls

    if(this.stateDefinitions?.definitions){
      this.stateList = Object.entries(this.stateDefinitions?.definitions)?.map(([key, data]) => ({
        key,
        ...data
      }));
    }
    if(this.dtcDetails?.rca) {
      this.rca.setValue(this.dtcDetails?.rca);
    }
    if (this.dtcDetails?.protusNumber) {
      // this.stateList = [...this.stateList?.filter(item => (item.id !== 'open' && item.id !== 're-open'))];
    }
    if (this.dtcDetails?.evidences?.length) {
      this.isAddEvidence = true;
      this.uploadedEvidences = this.dtcDetails?.evidences;
    }
    if (this.dtcDetails?.originalState) {
      const selectedState: { value: string, displayName: string, key: string } = this.stateList?.find((item) => item.value === this.dtcDetails?.originalState?.toLowerCase());
      setTimeout(() => {
        this.fetchRules(selectedState?.key);
      }, 0);
    }
    if (this.dtcDetails?.originalState === 'closed') {
      this.comment?.disable();
    } else {
      this.comment?.enable();
    }
    setTimeout(() => {
      this.showComment(false);
    }, 0);
    this._getProtusHistory();
  }

  ngOnDestroy(): any {
    this._fetchStatesSubsciption?.unsubscribe();
    this._updateCaseSubscription?.unsubscribe();
    this._configurationsInfoSubscription?.unsubscribe();
    this._getProtusHistorySubscription?.unsubscribe();
  }
  
  /**
   * Fetchs protus number title dynamically using translation
   * @returns  
   */
  fetchProtusTitle() {
    const key = 'protusNumber';
    const translation = this.translate.instant(key);
    this.translatedText = (translation && translation !== key) ? translation : 'Protus Number';
  }

  /**
   * Copys protus
   * @param protusName 
   */
  copyProtus(protusName: string) {
    this._clipboard.copy(protusName);
    this._service.toasterService({ type: 'success', msg: "Protus copied" });
  }

  fetchRules(selectedState: string) {
    const reqPayload = { module: this.pageType, fromState: selectedState, requestor: localStorage.getItem('userGroupName') ?? 'ANY'}
    this._fetchStatesSubsciption = this._caseService.fetchStates(reqPayload)?.subscribe(
      {
        next: (response: any) => {
          if (response) {
            this.ruleList = [...response];
            const availableStates = this.ruleList?.filter(item => item.action === "changeState")?.map(state => state.toState);
            this.stateList = this.stateList?.filter(item => availableStates?.includes(item?.key) || item?.value === this.dtcDetails?.originalState);
            this.state?.patchValue(this.dtcDetails?.originalState);
            const ruleChecks = Object.keys(this.applicableRules);

            ruleChecks.forEach(rule => {
              this.applicableRules[rule] = this.ruleList?.some(item => item.action === rule) || false;
            });
          }
        }, error: (error: any) => {
          this.stateList = [];
          this._service.toasterService({
            type: 'error',
            msg: 'Unable to fetch rules',
          });
        }
      });
  }

  handleClose(isClosed: boolean) {
    this.collapse.emit(isClosed);
  }

  openPopover(event: any) {
    this.formType = event?.type;
    if(event?.protusNumber || event?.protusName) {
      this.protusExists ? this.openReportReoccurenceForm = event?.isClosed : this.openAddProtus = event?.isClosed;
      this.saveProtusNumberAndName(event?.protusNumber, event?.protusName);
    } else {
      this.protusExists ? this.openReportReoccurenceForm = event : this.openAddProtus = event;
    }
  }

  saveProtusNumberAndName(protusNumber: string, protusName: string) {
    this.dtcDetails.protusName = protusName;
    this.dtcDetails.protusNumber = protusNumber;
    this.actionsPerformed.protusAdd = true;
  }

  addEvidence() {
    this.isAddEvidence = true;
  }

  private _setFileContent() {
    this.fileContent = {
      file: {
        fileUrl: this.file?.value,
        fileName: this.fileName?.value,
        fileSize: null,
        fileType: this._fileTypeService.getFileExtensionFromUrl(this.file?.value)
      }
    }
  }

  uploadResponse(event: Partial<BlobUploadResponse>, formControlName: string) {
    this._blobResponse[formControlName] = event;
    if (event?.stage === 'upload') {
      this._updateFileUploadedCount(event?.status, false);
      if (event?.fileUrl) {
        this.file?.patchValue(event?.fileUrl);
        this.selectedFileUrls?.push({ id: this.generateUid(), name: this.fileName?.value, url: event?.fileUrl });
        this.uploadedEvidences?.push({ id: this.generateUid(), name: this.fileName?.value, url: event?.fileUrl });
      }
      this.fileName?.reset();
      this.file?.reset();
      this.startFileBlobUpload = false;
      if (this.fileSelectedCount === this._fileUploadedCount) {
        this._saveFormData();
      }
    } else if (event?.stage === 'select') {
      this._updateFileSelectedCount(event?.status);
    } else if (event?.stage === 'exist-delete') {
      this._updateFileSelectedCount(!event?.status);
      this._updateFileUploadedCount(!event?.status);
    } else if (event?.stage === 'soft-delete') {
      this._updateFileSelectedCount(!event?.status);
    }
  }

  get fileSelectedCount() {
    return this._fileSelectedCount;
  }

  set fileSelectedCount(value: number) {
    this._fileSelectedCount = value;
    this._isAllFilesSelected = this.fileSelectedCount === this._TWO ? true : false;
  }

  private _updateFileSelectedCount(condition: boolean | string, hasDecrement: boolean = true) {
    condition ? this.fileSelectedCount++ : (hasDecrement ? this.fileSelectedCount-- : this.fileSelectedCount);
  }

  private _updateFileUploadedCount(condition: boolean | string, hasDecrement: boolean = true) {
    condition ? this._fileUploadedCount++ : (hasDecrement ? this._fileUploadedCount-- : this._fileUploadedCount);
  }

  onFormSubmit() {
    this.isUploadFormSubmitted = true;
    if (!this.fileName?.value || !this.file?.value) {
      return;
    }
    // Form status check
    this.startFileBlobUpload = this._blobResponse?.file ? true : false;
  }

  deleteFile(index: number, id: string) {
    this.fileContent = {
      file: {
        fileUrl: this.uploadedEvidences?.[index]?.url,
        fileName: this.uploadedEvidences?.[index]?.name,
        fileSize: null,
        fileType: this._fileTypeService.getFileExtensionFromUrl(this.uploadedEvidences?.[index]?.url)
      }
    }
    this.startFileBlobUpload = true;
    if (id) {
      this.uploadedEvidences = this.uploadedEvidences?.filter(item => item.id !== id);
    } else if (index >= 0 && index < this.uploadedEvidences?.length) {
      this.uploadedEvidences?.splice(index, 1); // Removes one element at the specified index
    }
    this.actionsPerformed.deleteEvidence = true;
    return this.uploadedEvidences;
  }

  downLoadFile(url: string, fileName: string) {
    window.open(url, "_blank");
  }

  // downLoadFile(blobUrl: string, fileName: string): void {
  //   const anchor = document.createElement('a');
  //   anchor.href = blobUrl;
  //   anchor.download = fileName;
  //   anchor.click();
  //   URL.revokeObjectURL(blobUrl);
  // }

  private _saveFormData() {
    this._setFileContent();
  }

  saveComment() {
    const reqPayload = {
      module: this.pageType,
      moduleId: this.dtcDetails?.caseId,
      commentText: this.comment?.value
    }
    this._caseService.addComments(reqPayload)?.subscribe(
      {
        next: (response: any) => {
          if (response) {
            this.comment?.reset();
            this.showComment(true);
            this._service.toasterService({
              type: 'success',
              msg: 'Comment added successfully',
            });
          }
        }, error: (error: any) => {
          this._service.toasterService({
            type: 'error',
            msg: 'Unable to add comment',
          });
        }
      });
  }

  showComment(show: boolean) {
    const reqPayload = {
      module: this.pageType,
      moduleId: this.dtcDetails?.caseId
    }
    this._caseService.getCommentsList(reqPayload)?.subscribe(
      {
        next: (response: any) => {
          if (response) {
            this.commentsList = [...response];
            this.showComments = show;
          }
        }, error: (error: any) => {
          this._service.toasterService({
            type: 'error',
            msg: 'Unable to fetch comments',
          });
        }
      });
  }

  generateUid(): string {
    return Math.random().toString(36).substr(2, 9); // Example: 'j5f3z8q9k'
  }

  onCaseSubmit() {
    if(this.selectedFileUrls?.length){
      this.actionsPerformed.updateCase = true;
    }
    if(this.state?.value !== this.dtcDetails?.originalState){
      this.actionsPerformed.changeState = true;
    }
    const actions = this.getTrueActions(this.actionsPerformed);
    const reqPayload = {
      caseId: this.dtcDetails?.caseId,
      data: {
        updateParams: {
          state: this.state?.value,
          evidences: this.uploadedEvidences,
          protusNumber: this.dtcDetails?.protusNumber,
          ...(this.rca?.value && {rca: this.rca?.value})
        },
        actions: actions,
        requestor: localStorage.getItem('userGroupName') ?? 'ANY'
      }
    }
    this._updateCaseSubscription = this._caseService.updateCaseDetails(reqPayload)?.subscribe(
      {
        next: (response: any) => {
          if (response) {
            this.collapse.emit(false);
            this._service.toasterService({
              type: 'success',
              msg: 'Saved successfully',
            });
          }
        }, error: (error: any) => {
          this._service.toasterService({
            type: 'error',
            msg: 'Unable to edit',
          });
        }
      });
  }

  getTrueActions(actions: { [key: string]: boolean }): string[] {
    return Object.entries(actions)
      .filter(([_, value]) => value)
      .map(([key]) => key);
  }

  getSeverityClass(severity: string): string {
    return severity ? severity?.toLocaleLowerCase()?.replace(/\s/g, '-') : '';
  }

  navigateToDtc(dtcId: string) {
    // this._router.navigate([`dtc/profile/${dtcId}`], { queryParams: { pageType: this.pageType } })
    if(this.pageType === 'case'){
      this._router.navigate([`dtc/dtcList`], { queryParams: { dtcId: dtcId, pageType: this.pageType, startDate: new Date(this._service.getDateState('case')?.date?.startDate),
        endDate: new Date(this._service.getDateState('case')?.date?.endDate) } })
    } else {
      this._router.navigate([`dtc/profile/${dtcId}`], { queryParams: { pageType: this.pageType } })
    }
  }

  /**
   * Gets configuration
   */
  private _getConfiguration() {
    let mappedConfigList = [];
    this._configurationsInfoSubscription = this._service.configurationsInfo(masterConfigurationList).subscribe({
      next: (data: any) => {
        if (data.status && data.response.length) {
          mappedConfigList = data.response.map((item: any) => {
            const obj = {};
            obj['attribute'] = item.attribute;
            obj['values'] = item.values;
            obj['_id'] = item._id;
            return obj;
          });
          this._service.setConfiguration(mappedConfigList);
        } else {
          this._service.setConfiguration(mappedConfigList);
        }
        if (!mappedConfigList.length) {
          this._service.toasterService({
            type: 'warning',
            msg: 'Configuration list is not available, please provide the required configuration for the app'
          });
        }
      },
      error: (error) => {
      }
    });
  }

  /**
   * Gets protus history
   */
  private _getProtusHistory() {
    let reqPayload: any = {};
    reqPayload.dtcId = this.dtcDetails?.dtcId;
    this._getProtusHistorySubscription = this._protusService?.getProtusList(1, reqPayload)?.subscribe(
      {
        next: (response: any) => {
          if (response?.data?.length) {
            this.protusDetails = response?.data;
            this.protusExists = true;
          } else {
            this.protusExists = false;
            this.protusDetails = [];
          };
        }, error: (error: any) => {
          this.protusExists = false;
          this.protusDetails = [];
        }
      });
  }
}
